import React, { useEffect, useState } from "react";
import PopUp from "../popUp/PopUp";
import Categories from "./Categories";
import "./Home.css";
import SliderHome from "./Slider";

const Home = () => {
  // const [popUp, setPopUp] = useState(true);

  // useEffect(() => {
  //   if (popUp) {
  //     <PopUp></PopUp>
  //   }
  // }, [])

  function ScrollToTopOnMount() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    return null;
  }

  return (
    <>
    
      <section className="home">
        <div className="d_flex">
          {/* <Categories /> */}
          <SliderHome />
        </div>
      </section>
    </>
  );
};

export default Home;
